<template>
  <div>
    <RevInfoBlock
      :icon="IconInfo"
      :title="i18n(translations.infoBlockTitle)"
      variant="info"
    />

    <Form withEncoding @submit="handleSubmit" />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconInfo } from '@ds/icons/IconInfo'

import type { FormValues } from '../../ExportDrawer.types'
import Form from '../Form/Form.vue'

import translations from './ExportAllOrders.translations'

const i18n = useI18n()

const emit = defineEmits(['submit'])

function handleSubmit(formValues: FormValues) {
  emit('submit', formValues)
}
</script>
